import { usePageCRUDActions } from '@mm/state/actions/PageCRUDActions';
import { usePageGroupCRUDActions } from '@mm/state/actions/PageGroupCRUDActions';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { UserRoleContainer } from '../../../../common/hooks/use-route-guard';

export const useFetchDialogues = () => {
  const activeChatbotId = useSelector(activeChatbotIdSelector);
  const {
    roleFlags: { isLiveChatAgent },
  } = UserRoleContainer.useContainer();

  const { retrieveAll: retrieveAllDialogues } = usePageCRUDActions();
  const { retrieveAll: retrieveAllDialogueFolders } = usePageGroupCRUDActions();

  useEffect(() => {
    if (isLiveChatAgent && activeChatbotId !== -1) {
      retrieveAllDialogues(activeChatbotId);
      retrieveAllDialogueFolders(activeChatbotId);
    }
  }, [isLiveChatAgent, activeChatbotId]);
};
